import Loader from './Loader';

interface LoadingStateProps {
  readonly message: string;
  readonly showAuthInfo?: boolean;
  readonly authInfo?: {
    readonly authProvider: string;
    readonly authInitialized: boolean;
  };
  readonly className?: string;
}

/**
 * Reusable loading state component
 * Consolidates loading UI patterns used across the application
 */
export function LoadingState({
  message,
  showAuthInfo = false,
  authInfo,
  className = 'min-h-screen flex items-center justify-center bg-gray-50',
}: LoadingStateProps) {
  return (
    <div className={className}>
      <div className="text-center">
        <Loader />
        <p className="mt-4 text-gray-600">{message}</p>
        {showAuthInfo && authInfo && (
          <p className="mt-2 text-sm text-gray-500">
            Auth initialized: {authInfo.authInitialized ? 'Yes' : 'No'}
          </p>
        )}
      </div>
    </div>
  );
}

/**
 * Authentication loading state component
 * Specialized loading state for authentication flows
 */
export function AuthLoadingState({
  provider,
  message,
}: {
  readonly provider: string;
  readonly message?: string;
}) {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
        <p className="text-gray-600">
          {message ?? `Authenticating with ${provider}...`}
        </p>
      </div>
    </div>
  );
}

export default LoadingState;
